import { render } from "./EmailAndPassword.vue?vue&type=template&id=af6b9ae2&scoped=true"
import script from "./EmailAndPassword.vue?vue&type=script&lang=js"
export * from "./EmailAndPassword.vue?vue&type=script&lang=js"

import "./EmailAndPassword.vue?vue&type=style&index=0&id=af6b9ae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6b9ae2"]])

export default __exports__